var map = {
	"./Stroke 1.png": 1199,
	"./Why Our Save the Dat.png": 1200,
	"./all_about_shipping@2x.png": 1201,
	"./ask_for_everything@2x.png": 1202,
	"./big-day@1x.png": 1203,
	"./big-day@2x.png": 1204,
	"./birds@1x.png": 1205,
	"./birds@2x.png": 1206,
	"./check-list@1x.png": 1207,
	"./check-list@2x.png": 1208,
	"./circle-better@1x.png": 1209,
	"./circle-better@2x.png": 1210,
	"./empty_rsvp.png": 1211,
	"./empty_rsvp2x.png": 1212,
	"./envelope.png": 748,
	"./envelope.svg": 1213,
	"./envelope@2x.png": 1214,
	"./events_doodle.png": 535,
	"./events_doodle.svg": 1215,
	"./gifts@1x.png": 1216,
	"./gifts@2x.png": 1217,
	"./guest-list@1x.png": 1218,
	"./guest-list@2x.png": 1219,
	"./guest.png": 1220,
	"./guest.svg": 1221,
	"./guest2x.png": 1222,
	"./guest_approved@2x.png": 1223,
	"./invitations@1x.png": 1224,
	"./invitations@2x.png": 1225,
	"./invites_paper.svg": 1226,
	"./invites_paper@1x.png": 1227,
	"./invites_paper@2x.png": 1228,
	"./laptop-one-heart.png": 1229,
	"./laptop-one-heart@2x.png": 1230,
	"./laptop@1x.png": 1231,
	"./laptop@2x.png": 1232,
	"./long-page-checklist.png": 1233,
	"./long-page-checklist@2x.png": 1234,
	"./make_it_personal@2x.png": 1235,
	"./namecard-with-name.png": 1236,
	"./namecard-with-name@2x.png": 1237,
	"./namecard_no_name.svg": 536,
	"./namecard_with_name.svg": 1238,
	"./namecard_with_question_marks.svg": 341,
	"./no_address.png": 1239,
	"./no_address2x.png": 1240,
	"./onboarding_1.png": 1241,
	"./onboarding_1@2x.png": 1242,
	"./onboarding_2.png": 1243,
	"./onboarding_2@2x.png": 1244,
	"./onboarding_3.png": 1245,
	"./onboarding_3@2x.png": 1246,
	"./onboarding_4.png": 1247,
	"./onboarding_4@2x.png": 1248,
	"./red-star-left@1x.png": 1249,
	"./red-star-left@2x.png": 1250,
	"./red-star-right@1x.png": 1251,
	"./red-star-right@2x.png": 1252,
	"./registry_publish_champagne.svg": 1253,
	"./rsvp@1x.png": 1254,
	"./rsvp@2x.png": 1255,
	"./save-the-date@1x.png": 1256,
	"./save-the-date@2x.png": 1257,
	"./sparkle-left.svg": 724,
	"./sparkle-right.svg": 725,
	"./sparkle-up.svg": 749,
	"./ta-da.png": 1258,
	"./ta-da@2x.png": 1259,
	"./talk.svg": 1260,
	"./talk@1x.png": 726,
	"./talk@2x.png": 727,
	"./timeline-line-dark@1x.png": 1261,
	"./timeline-line-dark@2x.png": 1262,
	"./timeline-line@1x.png": 1263,
	"./timeline-line@2x.png": 1264,
	"./tips.svg": 728,
	"./underline_long@1x.png": 1265,
	"./underline_long@2x.png": 1266,
	"./underline_sm@1x.png": 1267,
	"./underline_sm@2x.png": 1268,
	"./website_publish_confetti.svg": 537,
	"./wedding-websites@1x.png": 1269,
	"./wedding-websites@2x.png": 1270,
	"./wedding_help.png": 750,
	"./wedding_help.svg": 1271,
	"./wedding_help@2x.png": 1272
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 340;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 340
// module chunks = 50